<template>
  <div class="text-center leaderboard-wrapper">
    <div v-if="showEmoji" class="avatar-bubble">
      <div class="bubble" />
      <span
        class=" layout center horizontal center-justified animate__pulse animate__faster animate__animated animate__infinite"
      >
        {{ $store.state.audienceEmoji }}
      </span>
    </div>
    <p>{{ $t("alreadyAnswer") }}</p>
    <p>{{ $t("waitAndSeeHowYouDid") }}</p>
  </div>
</template>
<script>

export default {
  props: {
    showEmoji: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
